<template>
  <div class="row">
    <div class="col-xl-6 col-lg-8 xl-70 box-col-8">
      <p class="pb-4">About 6,000 results (0.60 seconds)</p>
      <div class="d-flex info-block">
        <iframe class="me-3 mb-3" width="200" height="100" src="https://www.youtube.com/embed/CJnfAXlBRTE"></iframe>
        <div class="flex-grow-1">
          <h4>
            Koho introduces a IELTS Coaching, TOEFL Coaching, GRE Coaching.
          </h4>
          <a href="javascript:void(0)" data-bs-original-title="" title="">kohoeducation.info/</a>
          <p>
            koho introduces a IELTS Coaching, TOEFL Coaching, GRE Coaching, GMAT
            Coaching, SAT Coaching in Surat.
          </p>
          <div class="star-ratings">
            <ul class="search-info">
              <li>2.5 stars</li>
              <li>590 votes</li>
              <li>Music</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="d-flex info-block">
        <iframe class="me-3 mb-3" width="200" height="100" src="https://www.youtube.com/embed/-L4gEk7cOfk"></iframe>
        <div class="flex-grow-1">
          <h4>
            Viho introduces a IELTS Coaching, TOEFL Coaching, GRE Coaching.
          </h4>
          <a href="javascript:void(0)" data-bs-original-title="" title="">Vihoeducation.info/</a>
          <p>
            Viho introduces a IELTS Coaching, TOEFL Coaching, GRE Coaching, GMAT
            Coaching, SAT Coaching in Surat.
          </p>
          <div class="star-ratings">
            <ul class="search-info">
              <li>2.5 stars</li>
              <li>590 votes</li>
              <li>Music</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="d-flex info-block">
        <iframe class="me-3 mb-3" width="200" height="100" src="https://www.youtube.com/embed/tRjG45ut8gU"></iframe>
        <div class="flex-grow-1">
          <h4>Koho Admin Dashboard Template</h4>
          <a href="javascript:void(0)">https://themeforest.net/</a>
          <p>
            koho introduces a IELTS Coaching, TOEFL Coaching, GRE Coaching, GMAT
            Coaching, SAT Coaching in Surat.
          </p>
          <div class="star-ratings">
            <ul class="search-info">
              <li>2.5 stars</li>
              <li>590 votes</li>
              <li>Music</li>
            </ul>
          </div>
        </div>
      </div>
      <video2View />
    </div>
    <div class="col-xl-6 col-lg-4 xl-30 box-col-30">
      <div class="row search-vid-block">
        <div class="col-xl-12 xl-100 box-col-12">
          <div class="embed-responsive embed-responsive-21by9 lg-mt">
            <iframe class="w-100" height="315" src="https://www.youtube.com/embed/wpmHZspl4EM"
              allowfullscreen=""></iframe>
          </div>
        </div>
        <div class="col-xl-12 xl-100 box-col-12">
          <div class="embed-responsive embed-responsive-21by9">
            <iframe class="w-100" height="315" src="https://www.youtube.com/embed/I0-vBdh4sZ8"
              allowfullscreen=""></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
import video2View from "./video2View.vue"
export default {
  components: {
    video2View
  }
}
</script>